var CONST = {
	CtrlManager: undefined,
	html5History: undefined,
	captureMouse: undefined,
  isMobile: window.innerWidth < 750,
  zendDeskSrc: 'https://static.zdassets.com/ekr/snippet.js?key=448cc81c-c911-4418-ab29-582d56647619',
};